<template>
  <div class="glossary">
    <Layout ref="layoutRef" :selectedOption="4" />
    <h4>Glosario de Términos Médicos</h4>
    <hr>
    <ul>
      <li v-for="term in glossary" :key="term.id">
        <strong>{{ term.name }}:</strong> {{ term.description }}
      </li>
    </ul>
    <Footer />

  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Glossary',
  components: {
    Layout, Footer
  },
  data() {
    return {
      glossary: [
        { id: 1, name: 'Cardiología', description: 'Rama de la medicina que se especializa en el diagnóstico y tratamiento de las enfermedades del corazón.' },
        { id: 2, name: 'Neurología', description: 'Especialidad médica que trata los trastornos del sistema nervioso.' },
      ]
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
}
</script>

<style>
.glossary ul {
  list-style: none;
  padding: 0;
}

.glossary li {
  margin-bottom: 10px;
}
</style>